import React, { useEffect, useState } from 'react';
import { ToastEvent } from '../utils/toastEvents';
import './ToastViewport.css';

interface ToastItem extends ToastEvent {
  id: number;
}

const ToastViewport: React.FC = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const handleToast = (event: Event) => {
      const toastEvent = event as CustomEvent<ToastEvent>;
      const toast = toastEvent.detail;
      if (!toast?.message) return;

      const id = Date.now() + Math.random();
      setToasts((current) => [...current.slice(-3), { ...toast, id }]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((item) => item.id !== id));
      }, 6500);
    };

    window.addEventListener('crm4chef:toast', handleToast);
    return () => window.removeEventListener('crm4chef:toast', handleToast);
  }, []);

  return (
    <div className="toast-viewport" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => (
        <section
          className={`app-toast app-toast--${toast.kind}`}
          key={toast.id}
          role={toast.kind === 'error' ? 'alert' : 'status'}
        >
          <div className="app-toast__content">
            <strong>{toast.title}</strong>
            <span>{toast.message}</span>
          </div>
          <button
            type="button"
            aria-label="Закрити сповіщення"
            onClick={() => setToasts((current) => current.filter((item) => item.id !== toast.id))}
          >
            ×
          </button>
        </section>
      ))}
    </div>
  );
};

export default ToastViewport;
